/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type ColorRole = typeof ColorRole[keyof typeof ColorRole];


export const ColorRole = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  DANGER: 'DANGER',
  FONT: 'FONT',
} as const;
